import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { useArt, useWorks, patchWork, WALL_STYLE } from "../../lib/art";
import { ArtShell } from "../../components/art/ArtShell";
import { GalleryWall } from "../../components/art/GalleryWall";
import { Framed } from "../../components/art/Framed";

export default function ArtGallery() {
  const nav = useNavigate();
  const [meta, reload, childId] = useArt();
  const [works, , setWorks] = useWorks();
  const [picking, setPicking] = useState(false);
  useEffect(() => { if (meta && !meta.full) nav("/pricing"); }, [meta, nav]);
  if (meta && !meta.full) return null;
  const shown = (works || []).filter((w) => w.in_gallery);
  const upd = (w) => setWorks((ws) => ws.map((x) => (x.work_id === w.work_id ? w : x)));
  const move = async (w, pos) => upd(await patchWork(w.work_id, pos));
  const setWall = async (wall) => { await api.put("/art/gallery", { wall }, { params: { child_id: childId } }); reload(); };
  const toggle = async (w) => { try { upd(await patchWork(w.work_id, { in_gallery: !w.in_gallery })); } catch { toast.error("失敗了，請再試一次"); } };
  return (
    <ArtShell title="我的小畫廊" testid="art-gallery-page"
      right={<button data-testid="gallery-pick-btn" onClick={() => setPicking(!picking)} className="h-12 px-5 rounded-full bg-[#1D6FB8] text-white font-bold">{picking ? "完成" : "挑選作品"}</button>}>
      <div className="flex flex-wrap items-center gap-2 mb-4" data-testid="gallery-walls">
        <span className="font-bold text-stone-600 mr-1">展示牆：</span>
        {meta?.walls.map((w) => (
          <button key={w.key} data-testid={`gallery-wall-${w.key}`} onClick={() => setWall(w.key)}
            className={`h-12 px-3 rounded-xl border-4 flex items-center gap-2 font-bold text-sm ${meta.wall === w.key ? "border-[#E2683C]" : "border-white"}`}>
            <span className="w-8 h-8 rounded-md" style={WALL_STYLE[w.key]} />{w.name}
          </button>
        ))}
      </div>
      {picking && (
        <div className="mb-6 rounded-3xl bg-white p-4 grid grid-cols-3 sm:grid-cols-6 gap-3" data-testid="gallery-picker">
          {(works || []).map((w) => (
            <button key={w.work_id} data-testid={`gallery-pick-${w.work_id}`} onClick={() => toggle(w)} className={`rounded-2xl p-1 border-4 ${w.in_gallery ? "border-[#3E9C8F]" : "border-transparent opacity-60"}`}>
              <Framed src={w.image_url} frame="none" /><span className="block text-xs mt-1 truncate">{w.in_gallery ? "✓ " : ""}{w.title}</span>
            </button>
          ))}
          {works && !works.length && <span className="col-span-full text-stone-500">先去畫一幅作品吧！</span>}
        </div>
      )}
      <p className="text-stone-500 mb-3">拖曳作品可以換位置，點一下可以放大看。</p>
      {meta && works && (shown.length ? <GalleryWall works={shown} wall={meta.wall} editable onMove={move} />
        : <div className="rounded-[2rem] p-16 text-center text-xl text-stone-500 border-4 border-dashed border-[#f3d9b8]" data-testid="gallery-empty">按「挑選作品」把畫掛上牆吧！</div>)}
    </ArtShell>
  );
}
